<template>
  <div class="footer">
    <div class="footer-pc">
      <div class="footer-main">
        <div class="footer-wrap main">
          <div class="logo-box">
            <p style="font-size:20px;margin-bottom:20px">咨询热线：</p>
            <p style="font-size:20px;margin-bottom:30px">400-8835-999</p>
            <p>售后服务 (故障申报)：400-8835-999（转1）</p>
            <p>业务咨询：400-8835-999（转2）</p>
            <p>网站备案：400-8835-999（转3）</p>
            <p>投诉建议：400-8835-999（转4）</p>
            <!-- <div class="logo" @click="enter('/')">
              <i class="iconfont icon-logo-w-01"></i>
            </div> -->

            <!--          <a href="https://www.netbank.cn/resource/Sdwan" style="color:#262222">SDWAN</a> -->
            <!-- <a href="https://www.netbank.cn/solution/ConAndMix" style="color:#262222">云原生</a> -->
          </div>
          <div class="link-box">
            <dl v-for="(item, key) in navs" :key="key">
              <dt @click="$router.push({ path: item.Durl })">{{ item.dt }}</dt>
              <dd v-for="(v, k) in item.dd" :key="k">
                <a v-if="!v.per" :href="v.url">{{ v.name }}</a>
                <span v-else>{{ v.name }}</span>
              </dd>
            </dl>
          </div>
          <div class="qr-box">
            <h3 class="qr-tit">关注网银互联</h3>
            <img src="../assets/footer/qrcode.png" />
          </div>
          <!-- <dl>
            <dt>联系方式</dt>
            <dd>地址: 杭州市西湖区华星路 96 号互联网金融大厦 20F</dd>

            <dd>市场合作: scb@netbank.cn</dd>

            <dd>业务咨询: 400-8835-999（转2）</dd>
          </dl>-->
        </div>
        <div class="info-box">
          <div class="info-tag">联系方式</div>
          <p>杭州市西湖区学院路28号德力西大厦1号楼1601-1602室</p>
          <p style="font-size:14px">
            市场合作：
            <span>scb@netbank.cn</span>
          </p>
        </div>
      </div>
      <div class="theCopyright">
        <div style="line-height: 59px;">
          <p style="display: inline;">
            Copyright©2021 杭州网银互联科技股份有限公司 All Rights Reserved | 备案号：
          </p>
          <a href="http://beian.miit.gov.cn" target="_blank" ref="nofollow" style="display: inline; color: #fff;">浙B2-20100146-2</a>
        </div>
      </div>
    </div>
    <div class="footer-phone">
      <div class="footer-content">
        <h2 class="footer-tit">关注网银互联</h2>
        <div class="footer-icon">
          <div class="icon" @click="openQrcode">
            <i class="iconfont mobicon-gongzhonghao" style="font-size: 0.46rem; top: 48%; left: 52%;"></i>
          </div>
          <div class="icon" v-clipboard:copy="'https://www.netbank.cn/'" v-clipboard:success="copySuccess">
            <i class="iconfont mobicon-zhuanfa" style="font-size: 0.37rem; top: 53%; left: 53%;"></i>
          </div>
        </div>
        <div class="footer-button">
          <div class="button red">
            <a href="https://url.cn/5uJjXZG?_type=wpa&qidian=true" target="_blank" rel="nofollow">在线咨询</a>
          </div>
          <div class="button">
            <a href="tel://400-883-5999">业务咨询</a>
          </div>
        </div>
        <div class="footer-info">
          <p>公司地址：杭州市西湖区学院路28号德力西大厦1号楼1601-1602室</p>
          <p style="width:360px">Copyright©2016 杭州网银互联科技股份有限公司 All Rights Reserved 浙B2-20100146-2</p>
          <!-- <p>杭州网银互联科技股份有限公司</p> -->
          <!-- <p>All Rights Reserved</p> -->
          <!-- <p>浙B2-20100146-2</p> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      navs: [
        {
          dt: "热门产品",
          dd: [
            {
              name: "GPU算力 | 算力服务",
              url: "/resource/ComputePower",
            },
            {
              name: "IDC服务 | 数据中心",
              url: "/resource/IdcDataCenter",
            },
            // {
            //   name: "LinkWAN | SD-WAN",
            //   url: "/resource/Sdwan"
            // },
            { name: "MDC网络融合 | 等保服务", url: "/resource/SafetyRule" },
            // { name: "LinkCloud | 容器云", url: "/resource/CubeCloud" }
          ],
        },
        {
          dt: "解决方案",
          dd: [
            {
              name: "算力服务解决方案",
              url: "/solution/ComputePower",
            },
            // { name: "容器DevOps解决方案", url: "/solution/DevOps" },
            { name: "数据中心定制解决方案", url: "/solution/dataCenter" },
            { name: "等保测评解决方案", url: "/solution/equalGuarantee" },
            { name: "企业安全解决方案", url: "/solution/entSecurity" },
          ],
        },
        {
          dt: "关于网银",
          dd: [
            { name: "关于我们", url: "/about/Introduction" },
            { name: "加入我们", url: "/about/Join" },
            { name: "新闻中心", url: "/about/News" },
          ],
        },
      ],
    };
  },
  methods: {
    enter(url) {
      if (url) {
        let a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("id", "startTelMedicine");
        // 防止反复添加
        if (document.getElementById("startTelMedicine")) {
          document.body.removeChild(document.getElementById("startTelMedicine"));
        }
        document.body.appendChild(a);
        a.click();
      }
    },
    openQrcode() {
      this.$parent.switchQrcode();
    },
    copySuccess() {
      this.$message({
        showClose: true,
        message: "链接复制成功！",
        type: "success",
        offset: 400,
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../style/variable.less";
@media screen and(min-width:@sm_min) {
  .footer-pc {
    height: 380px;
    width: 100%;
    background-color: #262222;
    .footer-main {
      width: 1200px;
      margin: 0 auto;
      .footer-wrap {
        height: 250px;
        display: flex;
        justify-content: space-around;
        font-weight: 300;
        padding-top: 40px;
        .logo-box {
          width: 320px;
          color: #fff;
          padding-top: 10px;
          border-right: 1px solid #685a5a;
          p {
            font-size: 12px;
            margin-bottom: 12px;
          }
          .logo {
            width: 200px;
            height: 80px;
            cursor: pointer;
            i {
              font-size: 65px;
            }
          }
        }
        .link-box {
          display: flex;
          justify-content: space-between;
          padding: 10px 50px 0;
          dl {
            margin-right: 100px;
            &:nth-child(3) {
              margin-right: 0;
            }
            dt {
              font-weight: 600;
              font-size: 14px;
              color: #fff;
              line-height: 25px;
            }
            dd {
              font-size: 12px;
              color: #fff;
              line-height: 36px;
              a {
                color: #fff;
                cursor: pointer;
                &:hover {
                  color: #ccc;
                }
              }
            }
          }
        }
        .qr-box {
          width: 240px;
          padding-left: 50px;
          border-left: 1px solid #685a5a;
          .qr-tit {
            color: #fff;
            font-size: 16px;
            margin-bottom: 20px;
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
      }

      .info-box {
        width: 100%;
        height: 70px;
        color: #fff;
        display: flex;
        font-size: 12px;
        align-items: center;
        justify-content: center;
        .info-tag {
          width: 70px;
          height: 24px;
          font-size: 14px;
          line-height: 22px;
          border-radius: 5px;
          text-align: center;
          margin-right: 10px;
          border: 1px solid #fff;
        }
        p {
          margin-right: 25px;
        }
      }
    }
    .theCopyright {
      height: 60px;
      width: 100%;
      color: #fff;
      font-size: 12px;
      text-align: center;
      border-top: 1px solid #3f3131;
    }
  }
  .footer-phone {
    display: none;
  }
}
@media screen and (min-width: @phone) and (max-width: @xs) {
  .footer-phone {
    background: #2a2120;
    position: relative;
    .footer-content {
      height: 6.5rem;
      .footer-tit {
        text-align: center;
        line-height: 1.4rem;
        font-size: 0.36rem;
        margin-bottom: 0.2rem;
        color: #fff;
        position: relative;
        &:before {
          content: "";
          width: 2.4rem;
          height: 1px;
          background: #999;
          position: absolute;
          top: 50%;
          left: 1rem;
          transform: translateY(-50%);
        }
        &:after {
          content: "";
          width: 2.4rem;
          height: 1px;
          background: #999;
          position: absolute;
          top: 50%;
          right: 1rem;
          transform: translateY(-50%);
        }
      }
      .footer-icon {
        width: 2.5rem;
        height: 0.85rem;
        margin: 0 auto;
        margin-bottom: 0.8rem;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        .icon {
          height: 0.85rem;
          width: 0.85rem;
          border-radius: 50%;
          border: 1px solid #fff;
          position: relative;

          i {
            color: #fff;
            position: absolute;
            // top: 50%;
            // left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
      .footer-button {
        width: 6.3rem;
        height: 0.64rem;
        margin: 0 auto;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        .button {
          width: 3rem;
          height: 0.8rem;
          color: #fff;
          border: 1px solid #fff;
          text-align: center;
          font-size: 0.35rem;
          display: flex;
          display: -webkit-flex;
          align-items: center;
          justify-content: center;
          a {
            color: #fff;
          }
        }
        .red {
          border: 1px solid #f72d2d;
          background: #f72d2d;
        }
      }
      .footer-info {
        position: absolute;
        left: 50%;
        bottom: 0.35rem;
        text-align: center;
        transform: translateX(-50%);
        p {
          font-size: 0.3rem;
          transform: scale(1);
          line-height: 0.4rem;
          transform-origin: top center;
        }
      }
    }
  }
  .footer-pc {
    display: none;
  }
}
/deep/.el-message {
  min-width: none;
  background-color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue